import { gql } from '@urql/core';

import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';
import { globalFeatureKeys } from '../_global/queries';

export const setEnabledGaProperties = ({ client, queryClient }) => ({
  mutationFn: ({ propertyIds }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation SetEnabledGaProperties($propertyIds: [Int!]!) {
          setEnabledGaProperties(propertyIds: $propertyIds) {
            id
          }
        }
      `,
      {
        propertyIds,
      },
    ),
  onSuccess: () => {
    queryClient.invalidateQueries({ ...globalFeatureKeys.me });
  },
});
